/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { AppMetadata } from "@adobe/genstudio-extensibility-sdk";

export const EXTENSION_ID: string = "genstudio-example:create-validation-app";
export const EXTENSION_LABEL: string =
  "GenStudioExample - Create Validation App";
export const ICON_DATA_URI: string =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTExIiBoZWlnaHQ9IjExMSIgdmlld0JveD0iMCAwIDExMSAxMTEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF85MV8zNDQ3NCkiPgo8cGF0aCBkPSJNOC44NDEgMEgxMDIuMTZDMTA0LjUwNSAwLjAwMDI2NTE5NyAxMDYuNzUzIDAuOTMxODQyIDEwOC40MTEgMi41ODk4MkMxMTAuMDY5IDQuMjQ3OCAxMTEgNi40OTYzOSAxMTEgOC44NDFWMTAyLjE2QzExMSAxMDQuNTA1IDExMC4wNjggMTA2Ljc1MyAxMDguNDEgMTA4LjQxMUMxMDYuNzUyIDExMC4wNjkgMTA0LjUwNCAxMTEgMTAyLjE1OSAxMTFIOC44NDFDNi40OTYyMiAxMTEgNC4yNDc0OCAxMTAuMDY5IDIuNTg5NDcgMTA4LjQxMUMwLjkzMTQ2IDEwNi43NTMgMCAxMDQuNTA0IDAgMTAyLjE1OUwwIDguODQxQzAgNi40OTYyMiAwLjkzMTQ2IDQuMjQ3NDggMi41ODk0NyAyLjU4OTQ3QzQuMjQ3NDggMC45MzE0NiA2LjQ5NjIyIDAgOC44NDEgMFoiIGZpbGw9IiNGRkVBMDAiLz4KPHBhdGggZD0iTTQ0LjU2MTIgNzguNDIzMUg1NC4xMjQyTDU5LjIzMTIgMzIuNTc4MUg1Mi45NDQyTDQ5LjIxMTIgNjguOTkyMUw0NS42MDkyIDMyLjU3ODFIMzguNjY3MkwzNS4xOTYyIDY4LjczMDFMMzEuMzMyMiAzMi41NzgxSDI0LjMyNDJMMjkuNDMyMiA3OC40MjMxSDM5LjMyNDJMNDEuOTQ0MiA1My45OTQxTDQ0LjU2MTIgNzguNDIzMVpNNzkuMjcyMiA3OC40MjMxSDg2LjY3MjJMNzYuNjUyMiA1My4wMTIxTDg2LjY3MzIgMzIuNTc4MUg3OS40NzMyTDcwLjAzODIgNTIuNTUzMVYzMi41NzgxSDYyLjgzODJWNzguNDIzMUg3MC4wMzgyVjY0LjM0MjFMNzIuMjY1MiA2MC4xNTAxTDc5LjI3MjIgNzguNDIzMVoiIGZpbGw9IiMyMDIwMjAiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF85MV8zNDQ3NCI+CjxyZWN0IHdpZHRoPSIxMTEiIGhlaWdodD0iMTExIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export const VALIDATION_PANEL_ROUTE: string = "/validation-panel";

/**
 * App metadata object
 * Configure this object as per your needs. Ex. specific options for validation.
 */
export const APP_METADATA: AppMetadata = {
  id: "<do not set this field, will be set by the extension registration>",
  label: EXTENSION_LABEL,
  iconDataUri: ICON_DATA_URI,
  supportedChannels: [
    {
      id: "email",
      name: "Email",
    },
  ],
  extensionId: EXTENSION_ID,
  options: {
    validation: {
      // autoOpenApp: true,
      // autoRefreshApp: true,
      // singleExperienceViewMode: true,
    },
  },
};
